const questionsWhatIsEthicalHacking = [
  {
    name: "What is the primary goal of ethical hacking?",
    options: [
      "To disrupt online services",
      "To test the security of systems and identify vulnerabilities",
      "To spread malware",
      "To cause harm to computer systems",
    ],
    correctAnswer: "To test the security of systems and identify vulnerabilities",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "Ethical hacking involves:",
    options: [
      "Illegally breaking into computer systems",
      "Identifying vulnerabilities and improving security",
      "Providing cybersecurity education",
      "Performing malicious activities for financial gain",
    ],
    correctAnswer: "Identifying vulnerabilities and improving security",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the main focus of ethical hacking?",
    options: [
      "Enhancing system performance",
      "Disrupting online services",
      "Defacing websites",
      "Discovering and fixing security weaknesses",
    ],
    correctAnswer: "Discovering and fixing security weaknesses",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "Which statement best describes ethical hackers?",
    options: [
      "They use their skills to help organizations secure their systems",
      "They are not skilled in computer programming",
      "They only use their skills for personal gain",
      "They are employed by criminal organizations",
    ],
    correctAnswer: "They use their skills to help organizations secure their systems",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What does an ethical hacker require permission for?",
    options: [
      "Accessing systems without authorization",
      "Testing security measures",
      "Removing security software",
      "Copying sensitive data",
    ],
    correctAnswer: "Testing security measures",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "Which term best describes ethical hacking?",
    options: [
      "Disrupting online services",
      "Unauthorized intrusion",
      "Malicious software distribution",
      "Securing systems through vulnerability testing",
    ],
    correctAnswer: "Securing systems through vulnerability testing",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary purpose of ethical hacking?",
    options: [
      "To identify vulnerabilities and weaknesses",
      "To promote illegal activities",
      "To compete in hacking competitions",
      "To cause harm",
    ],
    correctAnswer: "To identify vulnerabilities and weaknesses",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What role do ethical hackers play?",
    options: [
      "They aim to steal sensitive data",
      "They exploit vulnerabilities for personal gain",
      "They strengthen security by finding weaknesses",
      "They disrupt online services",
    ],
    correctAnswer: "They strengthen security by finding weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is a primary concern for organizations?",
    options: [
      "Maximizing security risks",
      "Avoiding any form of testing on their systems",
      "Minimizing security risks",
      "Hiding all vulnerabilities",
    ],
    correctAnswer: "Minimizing security risks",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about ethical hacking?",
    options: [
      "It's not a valuable skill",
      "It's only done by black hat hackers",
      "It's the same as cybercrime",
      "It doesn't involve any risks",
    ],
    correctAnswer: "It's the same as cybercrime",
    correctOption: "C",
    answerPicked: "",
  },
];

const questionsPenetrationTesting = [
  {
    name: "What is another term for penetration testing?",
    options: [
      "Black Hat Hacking",
      "Cyber Espionage",
      "Ethical Hacking",
      "Unauthorized Access",
    ],
    correctAnswer: "Ethical Hacking",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "Which activity does penetration testing involve?",
    options: [
      "Spreading viruses and malware",
      "Testing security defenses and finding vulnerabilities",
      "Breaking into systems without permission",
      "Distributed denial-of-service attacks",
    ],
    correctAnswer: "Testing security defenses and finding vulnerabilities",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the main purpose of penetration testing?",
    options: [
      "To distribute malware",
      "To strengthen security by identifying weaknesses",
      "To hack into systems without permission",
      "To exploit vulnerabilities for personal gain",
    ],
    correctAnswer: "To strengthen security by identifying weaknesses",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "Why is penetration testing important?",
    options: [
      "It disrupts online services",
      "It exposes vulnerabilities before malicious hackers can exploit them",
      "It guarantees 100% security",
      "It helps hackers steal data",
    ],
    correctAnswer: "It exposes vulnerabilities before malicious hackers can exploit them",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "Which of the following is NOT a goal of penetration testing?",
    options: [
      "Testing system performance under stress",
      "Obtaining unauthorized access to systems",
      "Identifying security weaknesses",
      "Evaluating the effectiveness of security measures",
    ],
    correctAnswer: "Obtaining unauthorized access to systems",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What type of testing is penetration testing?",
    options: [
      "An illegal activity",
      "A cybersecurity best practice",
      "A malicious activity",
      "A form of hacking for personal gain",
    ],
    correctAnswer: "A cybersecurity best practice",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the main difference between penetration testing and hacking?",
    options: [
      "Hacking involves unauthorized access, while penetration testing is authorized",
      "Hacking is done by black hat hackers only",
      "Penetration testing is always illegal",
      "Penetration testing is more destructive",
    ],
    correctAnswer: "Hacking involves unauthorized access, while penetration testing is authorized",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "Which term is commonly associated with ethical hacking?",
    options: [
      "Security breach",
      "Unauthorized intrusion",
      "White hat hacking",
      "System compromise",
    ],
    correctAnswer: "White hat hacking",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the main goal of penetration testers?",
    options: [
      "To promote illegal activities",
      "To spread malware",
      "To expose vulnerabilities and weaknesses",
      "To steal sensitive data",
    ],
    correctAnswer: "To expose vulnerabilities and weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "Why is penetration testing a crucial part of cybersecurity?",
    options: [
      "It simulates real-world attacks and improves defenses",
      "It helps organizations exploit vulnerabilities",
      "It guarantees 100% security",
      "It's only applicable to large corporations",
    ],
    correctAnswer: "It simulates real-world attacks and improves defenses",
    correctOption: "A",
    answerPicked: "",
  },
];

const questionsUnderstandingHackingRoles = [
  {
    name: "What are the different roles in hacking?",
    options: [
      "White hat, red hat, blue hat, green hat",
      "Black hat, gray hat, red hat, blue hat",
      "White hat, black hat, gray hat, red hat",
      "Blue hat, red hat, green hat, yellow hat",
    ],
    correctAnswer: "White hat, black hat, gray hat, red hat",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is a white hat hacker?",
    options: [
      "A hacker who always wears a white hat",
      "A hacker who only hacks for personal gain",
      "A hacker who hacks without permission",
      "A hacker who uses their skills for ethical purposes",
    ],
    correctAnswer: "A hacker who uses their skills for ethical purposes",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What do black hat hackers typically do?",
    options: [
      "Hack for ethical reasons",
      "Help organizations improve security",
      "Use their skills for malicious purposes",
      "Only hack into their own computers",
    ],
    correctAnswer: "Use their skills for malicious purposes",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "Gray hat hackers are known for:",
    options: [
      "Wearing gray hats while hacking",
      "Hacking for personal gain",
      "Hacking for both ethical and unethical reasons",
      "Hacking only for ethical purposes",
    ],
    correctAnswer: "Hacking for both ethical and unethical reasons",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of red teaming?",
    options: [
      "Defending against cyberattacks",
      "Conducting ethical hacking",
      "Testing blue team's skills and defenses",
      "Spreading malware and viruses",
    ],
    correctAnswer: "Testing blue team's skills and defenses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the role of the blue team?",
    options: [
      "To hack into systems",
      "To conduct penetration testing",
      "To defend against cyber threats",
      "To spread awareness about hacking",
    ],
    correctAnswer: "To defend against cyber threats",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is a purple team?",
    options: [
      "A team of hackers who wear purple clothing",
      "A team that combines red team and blue team activities",
      "A team of hackers who engage in illegal activities",
      "A team that exclusively performs penetration testing",
    ],
    correctAnswer: "A team that combines red team and blue team activities",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the main intention of ethical hackers when they discover vulnerabilities?",
    options: [
      "To report them so they can be fixed",
      "To exploit them for personal gain",
      "To sell them to the highest bidder",
      "To keep them secret for future use",
    ],
    correctAnswer: "To report them so they can be fixed",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What is the role of white hat hackers in organizations?",
    options: [
      "To cause harm to computer systems",
      "To spread malware and viruses",
      "To find and fix security vulnerabilities",
      "To engage in cyber espionage",
    ],
    correctAnswer: "To find and fix security vulnerabilities",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What distinguishes ethical hackers from malicious hackers?",
    options: [
      "Ethical hackers have permission to hack",
      "Ethical hackers are better at hacking",
      "Ethical hackers never use computers",
      "Ethical hackers have special uniforms",
    ],
    correctAnswer: "Ethical hackers have permission to hack",
    correctOption: "A",
    answerPicked: "",
  },
];

const questionsPenetrationTestingVsEthicalHacking = [
  {
    name: "What is the key difference between penetration testing and ethical hacking?",
    options: [
      "Ethical hacking involves hacking into systems without authorization",
      "Penetration testing is done by individuals without permission",
      "Hacking involves unauthorized access, while penetration testing is authorized",
      "Ethical hackers never cause any harm",
    ],
    correctAnswer: "Hacking involves unauthorized access, while penetration testing is authorized",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the primary objective of penetration testing?",
    options: [
      "To exploit vulnerabilities for personal gain",
      "To evaluate system performance",
      "To uncover security weaknesses and vulnerabilities",
      "To cause damage to computer systems",
    ],
    correctAnswer: "To uncover security weaknesses and vulnerabilities",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "Why is ethical hacking considered legal and acceptable?",
    options: [
      "Ethical hackers have special permissions from authorities",
      "Ethical hackers never cause any harm",
      "Ethical hackers only target small organizations",
      "Ethical hackers do not need permission to hack",
    ],
    correctAnswer: "Ethical hackers have special permissions from authorities",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "How does ethical hacking contribute to improving cybersecurity?",
    options: [
      "By exposing vulnerabilities before malicious hackers can exploit them",
      "By engaging in cyber espionage",
      "By conducting illegal hacking activities",
      "By spreading awareness about hacking techniques",
    ],
    correctAnswer: "By exposing vulnerabilities before malicious hackers can exploit them",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What is the main goal of ethical hacking?",
    options: [
      "To test the security of systems and networks",
      "To illegally access sensitive information",
      "To cause damage to computer systems",
      "To engage in cyber warfare",
    ],
    correctAnswer: "To test the security of systems and networks",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of ethical hacking?",
    options: [
      "Identifying vulnerabilities and weaknesses",
      "Gaining unauthorized access to systems",
      "Disrupting online services",
      "Hacking for financial gain",
    ],
    correctAnswer: "Identifying vulnerabilities and weaknesses",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "Which of the following is NOT a common goal of ethical hackers?",
    options: [
      "Enhancing system performance",
      "Identifying security flaws",
      "Preventing data breaches",
      "Strengthening network defenses",
    ],
    correctAnswer: "Enhancing system performance",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What distinguishes ethical hackers from malicious hackers?",
    options: [
      "Ethical hackers have permission to hack",
      "Ethical hackers are better at hacking",
      "Ethical hackers never use computers",
      "Ethical hackers have special uniforms",
    ],
    correctAnswer: "Ethical hackers have permission to hack",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "Why do organizations hire ethical hackers?",
    options: [
      "To prevent security breaches and data theft",
      "To engage in cybercriminal activities",
      "To create chaos and disruption",
      "To spread malware and viruses",
    ],
    correctAnswer: "To prevent security breaches and data theft",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What is the main intention of ethical hackers when they discover vulnerabilities?",
    options: [
      "To report them so they can be fixed",
      "To exploit them for personal gain",
      "To sell them to the highest bidder",
      "To keep them secret for future use",
    ],
    correctAnswer: "To report them so they can be fixed",
    correctOption: "A",
    answerPicked: "",
  },
];

const questionsWhyEthicalHackingIsImportant = [
  {
    name: "Why is ethical hacking important?",
    options: [
      "To spread malware and viruses",
      "To engage in illegal activities",
      "To disrupt online services",
      "To identify and fix security vulnerabilities",
    ],
    correctAnswer: "To identify and fix security vulnerabilities",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary goal of ethical hacking?",
    options: [
      "To promote illegal activities",
      "To test the security of systems and networks",
      "To gain unauthorized access to sensitive data",
      "To create chaos and disruption",
    ],
    correctAnswer: "To test the security of systems and networks",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "How does ethical hacking contribute to cybersecurity?",
    options: [
      "By spreading malware and viruses",
      "By promoting cybercrime",
      "By identifying and addressing security weaknesses",
      "By causing damage to computer systems",
    ],
    correctAnswer: "By identifying and addressing security weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about ethical hacking?",
    options: [
      "It's not a valuable skill",
      "It's only done by black hat hackers",
      "It's the same as cybercrime",
      "It doesn't involve any risks",
    ],
    correctAnswer: "It's the same as cybercrime",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "Why do organizations invest in ethical hacking?",
    options: [
      "To create chaos in the cybersecurity industry",
      "To spread awareness about hacking techniques",
      "To engage in malicious activities",
      "To proactively identify and mitigate security risks",
    ],
    correctAnswer: "To proactively identify and mitigate security risks",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of ethical hacking?",
    options: [
      "To gain unauthorized access to systems",
      "To disrupt online services",
      "To identify vulnerabilities and weaknesses",
      "To exploit security flaws for personal gain",
    ],
    correctAnswer: "To identify vulnerabilities and weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "How does ethical hacking help organizations?",
    options: [
      "By causing financial losses",
      "By revealing security weaknesses before malicious hackers exploit them",
      "By spreading malware and viruses",
      "By conducting illegal activities",
    ],
    correctAnswer: "By revealing security weaknesses before malicious hackers exploit them",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the main intention of ethical hackers when they find vulnerabilities?",
    options: [
      "To exploit them for personal gain",
      "To report them for financial rewards",
      "To keep them secret for future use",
      "To report them so they can be fixed",
    ],
    correctAnswer: "To report them so they can be fixed",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the ultimate goal of ethical hacking?",
    options: [
      "To create chaos and disruption",
      "To cause financial losses",
      "To help organizations improve security",
      "To engage in cyber warfare",
    ],
    correctAnswer: "To help organizations improve security",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "Why is ethical hacking a crucial aspect of modern cybersecurity?",
    options: [
      "Because it guarantees 100% security",
      "Because it's a fun and recreational activity",
      "Because it helps malicious hackers succeed",
      "Because it identifies vulnerabilities before they are exploited",
    ],
    correctAnswer: "Because it identifies vulnerabilities before they are exploited",
    correctOption: "D",
    answerPicked: "",
  },
];

const questionsBlackHatHackers = [
  {
    name: "Who are black hat hackers?",
    options: [
      "Hackers who hack for ethical reasons",
      "Hackers who hack for personal gain",
      "Hackers who use their skills for good purposes",
      "Hackers who hack only with permission",
    ],
    correctAnswer: "Hackers who hack for personal gain",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the main goal of black hat hackers?",
    options: [
      "To identify and fix security vulnerabilities",
      "To create chaos and disruption",
      "To help organizations improve security",
      "To gain unauthorized access for malicious purposes",
    ],
    correctAnswer: "To gain unauthorized access for malicious purposes",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "How do black hat hackers contribute to cybersecurity?",
    options: [
      "By identifying and addressing security weaknesses",
      "By promoting ethical hacking practices",
      "By conducting illegal hacking activities",
      "By spreading awareness about hacking techniques",
    ],
    correctAnswer: "By conducting illegal hacking activities",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What distinguishes black hat hackers from white hat hackers?",
    options: [
      "Black hat hackers hack for ethical reasons",
      "Black hat hackers never use computers",
      "Black hat hackers have special uniforms",
      "Black hat hackers hack for personal gain",
    ],
    correctAnswer: "Black hat hackers hack for personal gain",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of black hat hackers?",
    options: [
      "Identifying vulnerabilities and weaknesses",
      "Gaining unauthorized access for malicious purposes",
      "Helping organizations improve security",
      "Hacking for ethical reasons",
    ],
    correctAnswer: "Gaining unauthorized access for malicious purposes",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What role do black hat hackers play in cybersecurity?",
    options: [
      "To identify and fix security vulnerabilities",
      "To contribute to a more secure cyberspace",
      "To engage in cyber espionage",
      "To spread awareness about hacking techniques",
    ],
    correctAnswer: "To engage in cyber espionage",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "Why do black hat hackers engage in hacking activities?",
    options: [
      "To improve system security",
      "To help organizations strengthen defenses",
      "To exploit vulnerabilities for personal gain",
      "To contribute to ethical hacking practices",
    ],
    correctAnswer: "To exploit vulnerabilities for personal gain",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the primary intention of black hat hackers?",
    options: [
      "To help organizations improve security",
      "To spread awareness about cybersecurity",
      "To engage in cyber warfare",
      "To gain unauthorized access and cause harm",
    ],
    correctAnswer: "To gain unauthorized access and cause harm",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about black hat hackers?",
    options: [
      "They only hack for ethical reasons",
      "They are always caught by authorities",
      "They never use computers",
      "They are invincible and cannot be stopped",
    ],
    correctAnswer: "They are invincible and cannot be stopped",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "How do black hat hackers approach vulnerabilities?",
    options: [
      "They report them to authorities",
      "They help organizations fix them",
      "They exploit them for personal gain",
      "They engage in ethical hacking practices",
    ],
    correctAnswer: "They exploit them for personal gain",
    correctOption: "C",
    answerPicked: "",
  },
];

const questionsGrayHatHackers = [
  {
    name: "Who are gray hat hackers?",
    options: [
      "Hackers who only hack for personal gain",
      "Hackers who always have permission to hack",
      "Hackers who hack for ethical reasons",
      "Hackers who engage in illegal hacking activities",
    ],
    correctAnswer: "Hackers who engage in illegal hacking activities",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary goal of gray hat hackers?",
    options: [
      "To exploit security vulnerabilities for personal gain",
      "To gain unauthorized access for malicious purposes",
      "To identify and fix security vulnerabilities",
      "To help organizations improve security",
    ],
    correctAnswer: "To identify and fix security vulnerabilities",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "How do gray hat hackers contribute to cybersecurity?",
    options: [
      "By engaging in ethical hacking practices",
      "By conducting illegal hacking activities",
      "By spreading awareness about hacking techniques",
      "By identifying and addressing security weaknesses",
    ],
    correctAnswer: "By identifying and addressing security weaknesses",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What distinguishes gray hat hackers from other hacker types?",
    options: [
      "Gray hat hackers always have permission to hack",
      "Gray hat hackers hack for personal gain",
      "Gray hat hackers are invincible and cannot be stopped",
      "Gray hat hackers hack for ethical reasons",
    ],
    correctAnswer: "Gray hat hackers always have permission to hack",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of gray hat hackers?",
    options: [
      "Gaining unauthorized access for malicious purposes",
      "Identifying vulnerabilities and weaknesses",
      "Helping organizations improve security",
      "Engaging in cyber espionage",
    ],
    correctAnswer: "Identifying vulnerabilities and weaknesses",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What role do gray hat hackers play in the cybersecurity landscape?",
    options: [
      "To exploit security vulnerabilities",
      "To cause harm and disruption",
      "To contribute to ethical hacking practices",
      "To help organizations improve security with permission",
    ],
    correctAnswer: "To help organizations improve security with permission",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary intention of gray hat hackers?",
    options: [
      "To spread awareness about hacking techniques",
      "To gain unauthorized access and cause harm",
      "To contribute to ethical hacking practices",
      "To help organizations improve security",
    ],
    correctAnswer: "To help organizations improve security",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about gray hat hackers?",
    options: [
      "They are invincible and cannot be stopped",
      "They only hack for personal gain",
      "They always engage in illegal activities",
      "They never use computers",
    ],
    correctAnswer: "They always engage in illegal activities",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "How do gray hat hackers approach vulnerabilities?",
    options: [
      "They report them to authorities",
      "They exploit them for personal gain",
      "They help organizations fix them",
      "They engage in cyber espionage",
    ],
    correctAnswer: "They report them to authorities",
    correctOption: "A",
    answerPicked: "",
  },
  {
    name: "What is the main distinction between gray hat hackers and black hat hackers?",
    options: [
      "Gray hat hackers hack for ethical reasons",
      "Black hat hackers hack for personal gain",
      "Gray hat hackers always have permission to hack",
      "Black hat hackers never use computers",
    ],
    correctAnswer: "Gray hat hackers always have permission to hack",
    correctOption: "C",
    answerPicked: "",
  },
];

const questionsRedTeam = [
  {
    name: "What is a red team?",
    options: [
      "A team of hackers who only hack for personal gain",
      "A team of security experts who test system defenses",
      "A team of cybercriminals",
      "A team of government spies",
    ],
    correctAnswer: "A team of security experts who test system defenses",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the primary goal of a red team?",
    options: [
      "To spread malware and viruses",
      "To exploit security vulnerabilities for personal gain",
      "To help organizations improve security by identifying weaknesses",
      "To gain unauthorized access and cause harm",
    ],
    correctAnswer: "To help organizations improve security by identifying weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "How does a red team contribute to cybersecurity?",
    options: [
      "By conducting illegal hacking activities",
      "By spreading awareness about hacking techniques",
      "By identifying and addressing security weaknesses",
      "By promoting cyber espionage",
    ],
    correctAnswer: "By identifying and addressing security weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What distinguishes red team from other hacker types?",
    options: [
      "Red teams have special uniforms",
      "Red teams only hack for personal gain",
      "Red teams have permission to hack",
      "Red teams engage in cyber warfare",
    ],
    correctAnswer: "Red teams have permission to hack",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of a red team?",
    options: [
      "Gaining unauthorized access for malicious purposes",
      "Identifying vulnerabilities and weaknesses",
      "Spreading malware and viruses",
      "Engaging in cyber espionage",
    ],
    correctAnswer: "Identifying vulnerabilities and weaknesses",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What role does a red team play in cybersecurity?",
    options: [
      "To exploit security vulnerabilities",
      "To cause harm and disruption",
      "To engage in ethical hacking practices",
      "To help organizations improve security by testing defenses",
    ],
    correctAnswer: "To help organizations improve security by testing defenses",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary intention of a red team?",
    options: [
      "To spread awareness about hacking techniques",
      "To gain unauthorized access and cause harm",
      "To contribute to ethical hacking practices",
      "To help organizations improve security",
    ],
    correctAnswer: "To help organizations improve security",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about red teams?",
    options: [
      "They engage in cyber warfare",
      "They always hack for personal gain",
      "They only target small organizations",
      "They never use computers",
    ],
    correctAnswer: "They always hack for personal gain",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "How do red teams approach vulnerabilities?",
    options: [
      "They report them to authorities",
      "They exploit them for personal gain",
      "They help organizations fix them",
      "They engage in cyber espionage",
    ],
    correctAnswer: "They help organizations fix them",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the main goal of a red team's assessment?",
    options: [
      "To evaluate system performance under stress",
      "To spread malware and viruses",
      "To gain unauthorized access and cause harm",
      "To identify and address security weaknesses",
    ],
    correctAnswer: "To identify and address security weaknesses",
    correctOption: "D",
    answerPicked: "",
  },
];

const questionsBlueTeam = [
  {
    name: "What is a blue team?",
    options: [
      "A team of hackers who engage in illegal activities",
      "A team of security experts who defend against cyber threats",
      "A team of cybercriminals",
      "A team of government spies",
    ],
    correctAnswer: "A team of security experts who defend against cyber threats",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the primary goal of a blue team?",
    options: [
      "To exploit security vulnerabilities for personal gain",
      "To gain unauthorized access and cause harm",
      "To help organizations improve security by identifying weaknesses",
      "To defend against cyber threats and attacks",
    ],
    correctAnswer: "To defend against cyber threats and attacks",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "How does a blue team contribute to cybersecurity?",
    options: [
      "By conducting illegal hacking activities",
      "By spreading awareness about hacking techniques",
      "By identifying and addressing security weaknesses",
      "By promoting cyber espionage",
    ],
    correctAnswer: "By identifying and addressing security weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What distinguishes a blue team from other hacker types?",
    options: [
      "Blue teams engage in cyber warfare",
      "Blue teams only hack for personal gain",
      "Blue teams have permission to hack",
      "Blue teams have special uniforms",
    ],
    correctAnswer: "Blue teams have permission to hack",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of a blue team?",
    options: [
      "Gaining unauthorized access for malicious purposes",
      "Identifying vulnerabilities and weaknesses",
      "Spreading malware and viruses",
      "Defending against cyber threats and attacks",
    ],
    correctAnswer: "Defending against cyber threats and attacks",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What role does a blue team play in cybersecurity?",
    options: [
      "To exploit security vulnerabilities",
      "To cause harm and disruption",
      "To engage in ethical hacking practices",
      "To help organizations defend against cyber threats and attacks",
    ],
    correctAnswer: "To help organizations defend against cyber threats and attacks",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary intention of a blue team?",
    options: [
      "To spread awareness about hacking techniques",
      "To gain unauthorized access and cause harm",
      "To contribute to ethical hacking practices",
      "To help organizations improve security",
    ],
    correctAnswer: "To help organizations improve security",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about blue teams?",
    options: [
      "They engage in cyber warfare",
      "They always hack for personal gain",
      "They only target small organizations",
      "They never use computers",
    ],
    correctAnswer: "They always hack for personal gain",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "How do blue teams approach vulnerabilities?",
    options: [
      "They report them to authorities",
      "They exploit them for personal gain",
      "They help organizations fix them",
      "They engage in cyber espionage",
    ],
    correctAnswer: "They help organizations fix them",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the main goal of a blue team's activities?",
    options: [
      "To evaluate system performance under stress",
      "To spread malware and viruses",
      "To gain unauthorized access and cause harm",
      "To defend against cyber threats and attacks",
    ],
    correctAnswer: "To defend against cyber threats and attacks",
    correctOption: "D",
    answerPicked: "",
  },
];

const questionsPurpleTeam = [
  {
    name: "What is a purple team?",
    options: [
      "A team of hackers who engage in illegal activities",
      "A team of security experts who work together with red and blue teams",
      "A team of cybercriminals",
      "A team of government spies",
    ],
    correctAnswer: "A team of security experts who work together with red and blue teams",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "What is the primary goal of a purple team?",
    options: [
      "To exploit security vulnerabilities for personal gain",
      "To gain unauthorized access and cause harm",
      "To help organizations improve security by identifying weaknesses",
      "To collaborate and enhance coordination between red and blue teams",
    ],
    correctAnswer: "To collaborate and enhance coordination between red and blue teams",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "How does a purple team contribute to cybersecurity?",
    options: [
      "By conducting illegal hacking activities",
      "By spreading awareness about hacking techniques",
      "By identifying and addressing security weaknesses",
      "By promoting cyber espionage",
    ],
    correctAnswer: "By identifying and addressing security weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What distinguishes a purple team from other hacker types?",
    options: [
      "Purple teams engage in cyber warfare",
      "Purple teams only hack for personal gain",
      "Purple teams have permission to hack",
      "Purple teams have special uniforms",
    ],
    correctAnswer: "Purple teams have permission to hack",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of a purple team?",
    options: [
      "Gaining unauthorized access for malicious purposes",
      "Identifying vulnerabilities and weaknesses",
      "Spreading malware and viruses",
      "Collaborating and enhancing coordination between red and blue teams",
    ],
    correctAnswer: "Collaborating and enhancing coordination between red and blue teams",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What role does a purple team play in cybersecurity?",
    options: [
      "To exploit security vulnerabilities",
      "To cause harm and disruption",
      "To engage in ethical hacking practices",
      "To collaborate and enhance coordination between red and blue teams",
    ],
    correctAnswer: "To collaborate and enhance coordination between red and blue teams",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary intention of a purple team?",
    options: [
      "To spread awareness about hacking techniques",
      "To gain unauthorized access and cause harm",
      "To contribute to ethical hacking practices",
      "To help organizations improve security",
    ],
    correctAnswer: "To help organizations improve security",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about purple teams?",
    options: [
      "They engage in cyber warfare",
      "They always hack for personal gain",
      "They only target small organizations",
      "They never use computers",
    ],
    correctAnswer: "They always hack for personal gain",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "How do purple teams approach vulnerabilities?",
    options: [
      "They report them to authorities",
      "They exploit them for personal gain",
      "They help organizations fix them",
      "They engage in cyber espionage",
    ],
    correctAnswer: "They help organizations fix them",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the main goal of a purple team's activities?",
    options: [
      "To evaluate system performance under stress",
      "To spread malware and viruses",
      "To gain unauthorized access and cause harm",
      "To collaborate and enhance coordination between red and blue teams",
    ],
    correctAnswer: "To collaborate and enhance coordination between red and blue teams",
    correctOption: "D",
    answerPicked: "",
  },
];

const questionsWhiteHatHackers = [
  {
    name: "Who are white hat hackers?",
    options: [
      "Hackers who only target small organizations",
      "Hackers who engage in cyber warfare",
      "Hackers who use their skills for personal gain",
      "Hackers who use their skills to help organizations improve security",
    ],
    correctAnswer: "Hackers who use their skills to help organizations improve security",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary goal of white hat hackers?",
    options: [
      "To exploit security vulnerabilities for personal gain",
      "To engage in cyber espionage",
      "To identify and fix security weaknesses",
      "To spread malware and viruses",
    ],
    correctAnswer: "To identify and fix security weaknesses",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "How do white hat hackers contribute to cybersecurity?",
    options: [
      "By conducting illegal hacking activities",
      "By spreading awareness about hacking techniques",
      "By identifying and addressing security vulnerabilities",
      "By promoting cyber espionage",
    ],
    correctAnswer: "By identifying and addressing security vulnerabilities",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What distinguishes white hat hackers from other hacker types?",
    options: [
      "White hat hackers engage in cyber warfare",
      "White hat hackers only hack for personal gain",
      "White hat hackers have permission to hack",
      "White hat hackers have special uniforms",
    ],
    correctAnswer: "White hat hackers have permission to hack",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the primary focus of white hat hackers?",
    options: [
      "Gaining unauthorized access for malicious purposes",
      "Identifying vulnerabilities and weaknesses",
      "Spreading malware and viruses",
      "Identifying and addressing security vulnerabilities",
    ],
    correctAnswer: "Identifying and addressing security vulnerabilities",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What role do white hat hackers play in cybersecurity?",
    options: [
      "To exploit security vulnerabilities",
      "To cause harm and disruption",
      "To engage in ethical hacking practices",
      "To identify and address security vulnerabilities",
    ],
    correctAnswer: "To identify and address security vulnerabilities",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is the primary intention of white hat hackers?",
    options: [
      "To spread awareness about hacking techniques",
      "To gain unauthorized access and cause harm",
      "To contribute to ethical hacking practices",
      "To help organizations improve security",
    ],
    correctAnswer: "To help organizations improve security",
    correctOption: "D",
    answerPicked: "",
  },
  {
    name: "What is a common misconception about white hat hackers?",
    options: [
      "They engage in cyber warfare",
      "They always hack for personal gain",
      "They only target small organizations",
      "They never use computers",
    ],
    correctAnswer: "They always hack for personal gain",
    correctOption: "B",
    answerPicked: "",
  },
  {
    name: "How do white hat hackers approach vulnerabilities?",
    options: [
      "They report them to authorities",
      "They exploit them for personal gain",
      "They help organizations fix them",
      "They engage in cyber espionage",
    ],
    correctAnswer: "They help organizations fix them",
    correctOption: "C",
    answerPicked: "",
  },
  {
    name: "What is the main goal of white hat hackers' activities?",
    options: [
      "To evaluate system performance under stress",
      "To spread malware and viruses",
      "To gain unauthorized access and cause harm",
      "To identify and address security vulnerabilities",
    ],
    correctAnswer: "To identify and address security vulnerabilities",
    correctOption: "D",
    answerPicked: "",
  },
];



const quizIQuestions = [
  ...questionsWhatIsEthicalHacking,
  ...questionsPenetrationTesting,
  ...questionsUnderstandingHackingRoles,
  ...questionsPenetrationTestingVsEthicalHacking,
  ...questionsWhyEthicalHackingIsImportant,
  ...questionsWhiteHatHackers,
  ...questionsBlackHatHackers,
  ...questionsGrayHatHackers,
  ...questionsRedTeam,
  ...questionsBlueTeam,
  ...questionsPurpleTeam
];

const quizzes = [
  {
    name: "Introduction to Ethical Hacking",
    id: 2,
    timer: {
      minutes: 30,
      seconds: 0,
    },
    imgUrl: "https://www.astatraining.com/wp-content/uploads/2020/03/what-is-an-ethical-hacker.jpg",
    slug: "introduction-to-ethical-hacking",
    description: "",
    author: "Admin",
    questions: [
      ...quizIQuestions
    ],
  }
]

  
const tests = [...quizzes];
  
export default tests;